import {
  STAFF_CONTACT_TYPE_LIST, STAFF_CONTACT_TYPE_LIST_SUCCESS, STAFF_CONTACT_TYPE_LIST_FAILURE,
  STAFF_CONTACT_TYPE_CREATE, STAFF_CONTACT_TYPE_CREATE_SUCCESS, STAFF_CONTACT_TYPE_CREATE_FAILURE,
  STAFF_CONTACT_TYPE_UPDATE, STAFF_CONTACT_TYPE_UPDATE_SUCCESS, STAFF_CONTACT_TYPE_UPDATE_FAILURE,
  STAFF_CONTACT_TYPE_DELETE, STAFF_CONTACT_TYPE_DELETE_SUCCESS, STAFF_CONTACT_TYPE_DELETE_FAILURE,
  STAFF_CONTACT_LIST, STAFF_CONTACT_LIST_SUCCESS, STAFF_CONTACT_LIST_FAILURE,
  STAFF_CONTACT_CREATE, STAFF_CONTACT_CREATE_SUCCESS, STAFF_CONTACT_CREATE_FAILURE,
  STAFF_CONTACT_UPDATE, STAFF_CONTACT_UPDATE_SUCCESS, STAFF_CONTACT_UPDATE_FAILURE,
  STAFF_CONTACT_DELETE, STAFF_CONTACT_DELETE_SUCCESS, STAFF_CONTACT_DELETE_FAILURE,
} from "./actionType";

const initialState = {
  staffContactTypeList: [], staffContactTypeListLoading: false,
  staffContactTypeCreate: [], staffContactTypeCreateLoading: false,
  staffContactTypeUpdate: [], staffContactTypeUpdateLoading: false,
  staffContactTypeDelete: [], staffContactTypeDeleteLoading: false,
  staffContactList: [], staffContactListLoading: false,
  staffContactCreate: [], staffContactCreateLoading: false,
  staffContactUpdate: [], staffContactUpdateLoading: false,
  staffContactDelete: [], staffContactDeleteLoading: false,
};

const StaffContact = (state = initialState, action) => {
  switch (action.type) {
    case STAFF_CONTACT_TYPE_LIST:         return { ...state, staffContactTypeListLoading: true };
    case STAFF_CONTACT_TYPE_LIST_SUCCESS: return { ...state, staffContactTypeList: action.payload, staffContactTypeListLoading: false };
    case STAFF_CONTACT_TYPE_LIST_FAILURE: return { ...state, staffContactTypeList: [], staffContactTypeListLoading: false };

    case STAFF_CONTACT_TYPE_CREATE:         return { ...state, staffContactTypeCreateLoading: true };
    case STAFF_CONTACT_TYPE_CREATE_SUCCESS: return { ...state, staffContactTypeCreate: action.payload, staffContactTypeCreateLoading: false };
    case STAFF_CONTACT_TYPE_CREATE_FAILURE: return { ...state, staffContactTypeCreate: [], staffContactTypeCreateLoading: false };

    case STAFF_CONTACT_TYPE_UPDATE:         return { ...state, staffContactTypeUpdateLoading: true };
    case STAFF_CONTACT_TYPE_UPDATE_SUCCESS: return { ...state, staffContactTypeUpdate: action.payload, staffContactTypeUpdateLoading: false };
    case STAFF_CONTACT_TYPE_UPDATE_FAILURE: return { ...state, staffContactTypeUpdate: [], staffContactTypeUpdateLoading: false };

    case STAFF_CONTACT_TYPE_DELETE:         return { ...state, staffContactTypeDeleteLoading: true };
    case STAFF_CONTACT_TYPE_DELETE_SUCCESS: return { ...state, staffContactTypeDelete: action.payload, staffContactTypeDeleteLoading: false };
    case STAFF_CONTACT_TYPE_DELETE_FAILURE: return { ...state, staffContactTypeDelete: [], staffContactTypeDeleteLoading: false };

    case STAFF_CONTACT_LIST:         return { ...state, staffContactListLoading: true };
    case STAFF_CONTACT_LIST_SUCCESS: return { ...state, staffContactList: action.payload, staffContactListLoading: false };
    case STAFF_CONTACT_LIST_FAILURE: return { ...state, staffContactList: [], staffContactListLoading: false };

    case STAFF_CONTACT_CREATE:         return { ...state, staffContactCreateLoading: true };
    case STAFF_CONTACT_CREATE_SUCCESS: return { ...state, staffContactCreate: action.payload, staffContactCreateLoading: false };
    case STAFF_CONTACT_CREATE_FAILURE: return { ...state, staffContactCreate: [], staffContactCreateLoading: false };

    case STAFF_CONTACT_UPDATE:         return { ...state, staffContactUpdateLoading: true };
    case STAFF_CONTACT_UPDATE_SUCCESS: return { ...state, staffContactUpdate: action.payload, staffContactUpdateLoading: false };
    case STAFF_CONTACT_UPDATE_FAILURE: return { ...state, staffContactUpdate: [], staffContactUpdateLoading: false };

    case STAFF_CONTACT_DELETE:         return { ...state, staffContactDeleteLoading: true };
    case STAFF_CONTACT_DELETE_SUCCESS: return { ...state, staffContactDelete: action.payload, staffContactDeleteLoading: false };
    case STAFF_CONTACT_DELETE_FAILURE: return { ...state, staffContactDelete: [], staffContactDeleteLoading: false };

    default: return state;
  }
};

export default StaffContact;
